<template>
  <v-container>
    <vue-headful title="Feedback" description="Aimz"/>

    <v-container style="max-width: 300px;" v-if="!success">
      <v-row class="pt-0 pb-0" >
<!--          <header1 class="my-5">Feedback</header1>-->
        <center-container>
          <a href="https://aimz.azurewebsites.net">
            <v-img class="" :src="require('@/assets/aimz.svg')" width="260"></v-img>
          </a>
        </center-container>
      </v-row>
      <v-row>
        <v-col class="my-5 mx-2" v-if="(data||{}).user">
          <p><b>{{data.user}}</b> hätte gerne Feedback von Dir.</p>
          <v-textarea class="my-3" :rows="4" auto-grow color="accent" ref="textarea"
                      outlined hide-details
                      name="comment"
                      label="Mein Feedback"
                      v-model="feedbackText"
          ></v-textarea>
          <div class="d-flex">
            <v-btn class="mt-5 ml-auto" @click="onSendFeedback" :disabled="!feedbackText">Absenden</v-btn>
          </div>
        </v-col>
        <v-col class="my-5 mx-2" v-else>
          <p>
            Invalid data!<br>
            Info: {{info}}<br>
            JSON: {{json}}<br>
            Object: {{data}}
          </p>
        </v-col>
      </v-row>
    </v-container>
    <v-container style="max-width: 300px;" v-if="success">
      <p class="display-1">Danke!</p>
    </v-container>
  </v-container>
</template>

<script>
import CenterContainer from "@/components/CenterContainer";
import Header1 from "@/components/Header1";

export default {
  name: 'Feedback',
  components: {CenterContainer, Header1  },
  data() {return{
    success:false,
    info:undefined,
    data:undefined,
    json: undefined,
    feedbackText:undefined,
    emailRules: [
      v => !!v || 'Bitte ausfüllen',
      v => /.+@.+/.test(v) || 'Ungültige Email',
    ],
  }},
  mounted() {
    if (!this.$route.params.data)
      return;
    this.info=this.$route.params.data;
    this.json=atob(this.info);
    this.data=JSON.parse(this.json);
  },
  methods:{
    onSendFeedback() {
      this.$backend.external_feedback(this.info, this.feedbackText, { onSuccess:this.onSuccess, onError:this.onError });
    },
    onSuccess() {
      this.success=true;
    },
    onError() {
    },
    onHasAccount(email) {
      if (email) {
        this.$router.replace("/login/"+email);
      }
    }
  },
  computed: {
    knr() {
      return this.$route.params.knr;
    },
    is_logged_in() {
      return !!this.$store.state.token;
    },
  },
  beforeDestroy() {
    document.removeEventListener( 'keydown', this.onKeyDown);
  },
}
</script>

<style>
  .rb {
    border: red 1px solid;
  }
  .full_width {
    width: 100%;
  }
</style>